/* eslint eqeqeq:'off' */
import React, {Component} from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import WorkOrderTenants from "./WorkOrderTenants";
import WorkOrderBuildings from "./WorkOrderBuildingList";
import EquipmentList from "./_ModalsForms/EquipmentList";
import WorkOrderSetup from "./_ModalsForms/WorkOrderSetup";
import PreventativeMaintenanceSetup from "./_ModalsForms/PreventativeMaintenanceSetup";
import ServiceRequestSetUp from "./_ModalsForms/ServiceRequestSetup";
import { connect } from 'react-redux';

class NestedTab extends Component{
    constructor(props){
        super(props);
        this.state = {
            activeTab : 1,
            activeContent : 1
        };
        this.toggle = this.toggle.bind(this);
    }
    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                activeContent: tab,
            });
        }
    }
    render(){
        let label = this.props.getLabels;
        let active_content = null, static_content = null;
        static_content=<div style ={{'margin-left': '25px','margin-top': '15px'}}>
                            <Nav>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab == '1' }, "NestedTab_header_link", "link_cursor")} onClick={() => { this.toggle('1'); }}>{label['WorkOrderstab.Tenants.Text']!== undefined ? label['WorkOrderstab.Tenants.Text'] : "TENANTS"}</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab == '2' }, "NestedTab_header_link", "link_cursor", "Tab_space")} onClick={() => { this.toggle('2'); }}>{label['WorkOrderstab.Buildings.Text']!== undefined ? label['WorkOrderstab.Buildings.Text'] : "BUILDINGS"}</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab == '3' }, "NestedTab_header_link", "link_cursor", "Tab_space")} onClick={() => { this.toggle('3'); }}>{label['WorkOrderstab.Equipment.Text']!== undefined ? label['WorkOrderstab.Equipment.Text'] : "EQUIPMENT"}</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab == '4' }, "NestedTab_header_link", "link_cursor", "Tab_space")} onClick={() => { this.toggle('4'); }}>{label['WorkOrderstab.Workordersetup.Text']!== undefined ? label['WorkOrderstab.Workordersetup.Text'] : "WORK ORDER SETUP"}</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab == '5' }, "NestedTab_header_link", "link_cursor", "Tab_space")} onClick={() => { this.toggle('5'); }}>{label['WorkOrderstab.PMsetup.Text']!== undefined ? label['WorkOrderstab.PMsetup.Text'] : "PREVENTATIVE MAINTENANCE SETUP"}</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: this.state.activeTab == '6' }, "NestedTab_header_link", "link_cursor", "Tab_space")} onClick={() => { this.toggle('6'); }}>{label['WorkOrderstab.Servicerequest.Text']!== undefined ? label['WorkOrderstab.Servicerequest.Text'] : "SERVICE REQUEST FORM SETUP"}</NavLink>
                                    </NavItem>
                            </Nav>
                        </div>

        if (this.state.activeContent == 1) {
            active_content = 
                <TabContent activeTab="1" style={{'margin-top':'-25px'}}>
                    <TabPane tabId="1"><WorkOrderTenants Premise={this.props.Premise} /></TabPane>
                </TabContent>
        }
        else if (this.state.activeContent == 2) {
        active_content = 
            <TabContent activeTab="2" style={{'margin-top':'-25px'}}>
                <TabPane tabId="2"><WorkOrderBuildings Premise={this.props.Premise} /></TabPane>
            </TabContent>
        }
        else if (this.state.activeContent == 3) {
            active_content = 
                <TabContent activeTab="3" style={{'margin-top':'-25px'}}>
                    <TabPane tabId="3"><EquipmentList Premise={this.props.Premise} /></TabPane>
                </TabContent>
        }
        else if (this.state.activeContent == 4) {
            active_content = 
                <TabContent activeTab="4" style={{'margin-top':'-25px'}}>
                    <TabPane tabId="4"><WorkOrderSetup Premise={this.props.Premise} /></TabPane>
                </TabContent>
        }
        else if (this.state.activeContent == 5) {
            active_content = 
            <TabContent activeTab="5" style={{'margin-top':'-25px'}}>
                <TabPane tabId="5"><PreventativeMaintenanceSetup Premise={this.props.Premise} /></TabPane>
            </TabContent>
        }
        else{
            active_content = 
            <TabContent activeTab="6" style={{'margin-top':'-25px'}}>
                <TabPane tabId="6"><ServiceRequestSetUp Premise={this.props.Premise} /></TabPane>
            </TabContent>
        }
        return (
            <div>
                {static_content}
                {active_content}
            </div>
        )
    }
   
}
const mapStateToProps = state => {
    return {
      
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
    };
};

export default connect(mapStateToProps,null)(NestedTab);